import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import IndicatorList from "./IndicatorList";
import CoordinatorList from "./CoordinatorList";
import { Divider } from "@mui/material";
import Box from "@mui/material/Box";
import dayjs from "dayjs";
import Typography from "@mui/material/Typography";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";

export default function ReportShowInfo({ report }) {
  if (!report) {
    return (
      <Typography variant="body1" color="text.secondary">
        No hay reporte disponible.
      </Typography>
    );
  }

  return (
    <Paper elevation={0} sx={{ padding: 5 }}>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
          Análisis y dictamen
        </Typography>
        <Divider sx={{ mb: 3 }} />
      </Grid>

      <Grid container spacing={2}>
        {/* Unidad académica */}
        <Grid item xs={6}>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Unidad académica:
            </Typography>
            {report.academic_unit}
          </Box>
        </Grid>

        {/* Carrera */}
        <Grid item xs={6}>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Carrera:
            </Typography>
            {report.career}
          </Box>
        </Grid>

        {/* Coordinadores */}
        <Grid item xs={6}>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Coordinador/es designado/s:
            </Typography>
            <Box sx={{ pl: 1 }}>
              <CoordinatorList coordinators={report.coordinators} />
            </Box>
          </Box>
        </Grid>

        {/* Propuesta */}
        <Grid item xs={6}>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Celebrado a propuesta de:
            </Typography>
            {report.proposal}
          </Box>
        </Grid>

        {/* Período evaluado */}
        <Grid item xs={6}>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Período evaluado:
            </Typography>
            {report.evaluated_period}
          </Box>
        </Grid>

        {/* Dependencia evaluadora */}
        <Grid item xs={6}>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Dependencia evaluadora:
            </Typography>
            {report.evaluation_unit}
          </Box>
        </Grid>

        {/* Indicadores */}
        {report.report_type === "Específico" && report.indicators && (
          <Grid item xs={12}>
            <IndicatorList
              indicators={report.indicators}
              showButtons={false}
              setIndicators={false}
              onlyShow={true}
            />
          </Grid>
        )}

        {/* Fecha de presentación */}
        <Grid item xs={6}>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Fecha de presentación:
            </Typography>
            {dayjs(report.presentation_date).format("DD/MM/YYYY")}
          </Box>
        </Grid>

        {/* Observación */}
        <Grid item xs={6}>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Observación:
            </Typography>
            {report.observation}
          </Box>
        </Grid>

        {/* Archivos adjuntados */}
        <Grid item xs={12} sx={{ mt: 4 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
            Archivos adjuntados:
          </Typography>

          {report.files && report.files.length > 0 ? (
            <Box
              sx={{
                width: "100%",
                overflowX: "auto",
                border: "1px solid #ccc",
                borderRadius: 2,
                p: 2,
              }}
            >
              <DocViewer
                documents={report.files.map((file) => ({
                  uri: file.uri,
                  fileName: file.fileName,
                  fileType: file.fileType,
                }))}
                pluginRenderers={DocViewerRenderers}
                style={{ height: 500, width: "100%" }}
              />
            </Box>
          ) : (
            <Typography variant="body2" color="text.secondary">
              No hay archivos adjuntos.
            </Typography>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
}
